import { render, staticRenderFns } from "./MobileSortSelection.vue?vue&type=template&id=60873228&scoped=true&"
import script from "./MobileSortSelection.vue?vue&type=script&lang=ts&"
export * from "./MobileSortSelection.vue?vue&type=script&lang=ts&"
import style0 from "./MobileSortSelection.vue?vue&type=style&index=0&id=60873228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60873228",
  null
  
)

export default component.exports